import React from 'react';

const BrandMark = ({ className = "w-8 h-8", color = "currentColor" }) => (
  <svg 
    viewBox="0 0 40 40" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg" 
    className={className}
  >
    <rect width="40" height="40" fill={color === "white" ? "#18181b" : "#f5f5f5"} />
    <path 
      d="M10 15C10 15 15 12 20 12C25 12 30 15 30 15V28C30 28 25 25 20 25C15 25 10 28 10 28V15Z" 
      stroke={color === "white" ? "white" : "#18181b"} 
      strokeWidth="1.5" 
    />
    <path 
      d="M20 12V8M17 8H23" 
      stroke="#d90429" 
      strokeWidth="1.5" 
      strokeLinecap="round" 
    />
    <path 
      d="M12 20L28 20" 
      stroke={color === "white" ? "rgba(255,255,255,0.2)" : "rgba(0,0,0,0.1)"} 
      strokeWidth="1" 
    />
  </svg>
);

export default BrandMark;